<template>
  <div class="chart-container">
    <div class="chart-main-container">
      <chart ref="chart" chartType="bar" chartId="PacfChart" :width="836" :height="size === 'mini' ? 300 : 400"></chart>
    </div>
  </div>
</template>

<script lang="js">
import ChartCmp from './base.vue'
import CommonUtil from '../../utils/common'
import { GraphBarColorSet } from '../../defines/chart-color'
import { FigurePreviewPacf, FigurePreviewPacfResult } from '../../defines/model/figure'

export default {
  name: 'PacfChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    pacf: FigurePreviewPacf,
    selectedType: '',
    size: '',
    selectedColumnIndex: {type: Number, default: 0},
    visible: Boolean
  },
  data () {
    return {
      selectedPacfResult: FigurePreviewPacfResult
    }
  },
  created () {
    this.selectedPacfResult = this.pacf.results[this.selectedColumnIndex]
  },
  watch: {
    selectedColumnIndex (newIndex) {
      if (!this.visible) return
      if (newIndex < 0) return
      this.selectedPacfResult = this.pacf.results[newIndex]
    },
    selectedPacfResult (pacfResult) {
      if (CommonUtil.isEmpty(pacfResult)) return

      const lag = pacfResult.value.map(value => value.lag)
      const value = pacfResult.value.map(value => value.value)
      const isMini = this.size === 'mini'

      let datasets = [
        Object.assign(
          {
            data: value,
            type: 'bar',
            yAxisID: 'value',
            fill: false,
            lineTension: 0,
            pointBorderWidth: isMini ? 4 : 8
          },
          GraphBarColorSet.blue
        )
      ]

      const chartData = {
        labels: lag,
        datasets: datasets
      }

      const options = {
        responsive: isMini,
        title: {
          display: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              id: 'value',
              position: 'left',
              scaleLabel: {
                display: false
              },
              ticks: {
                beginAtZero: false,
                major: {},
                minor: {}
              }
            }
          ],
          xAxes: [
            {
              display: false,
              ticks: {
                beginAtZero: false,
                maxRotation: 90,
                major: {},
                minor: {}
              }
            }
          ]
        }
      }

      this.$refs.chart.renderChart(chartData, options)
    }
  }
}

</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/pacf.vue